window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */


// variant switcher

function update_titleVariant(currentVariant){
  let default_productTitle = $('div[data-default-product-title]').text().trim();
  let duplicate_pTitle;
  const variants = document.querySelectorAll('.variant_title-data[data-customfield-variant-id]');
  if($('h1[data-variant-title-switcher]').length == 2){
    duplicate_pTitle = true;
  } else{
    duplicate_pTitle = false;
  }
  
  if(variants.length != 0){
    let set_default_title = 0;
    for(i=0; i < variants.length; i++){
     let selectedVal = variants[i].innerHTML.trim();
      if(variants[i].dataset.customfieldVariantId == currentVariant){
        set_default_title = 1;
        if(duplicate_pTitle == true){
          $('h1[data-variant-title-switcher]')[0].innerHTML = selectedVal;    
          $('h1[data-variant-title-switcher]')[1].innerHTML = selectedVal;
        } else{
           $('h1[data-variant-title-switcher]')[0].innerHTML = selectedVal;
        }
      }
    }
    if(set_default_title == 0){
        if(duplicate_pTitle == true){
          $('h1[data-variant-title-switcher]')[0].innerHTML = default_productTitle;    
          $('h1[data-variant-title-switcher]')[1].innerHTML = default_productTitle;    
        } else{
           $('h1[data-variant-title-switcher]')[0].innerHTML = default_productTitle;
        }
    }
  }
}

function update_descrVariant(currentVariant){
  if($('div[data-variant-descr-switcher]').length != 0){
    let default_productDescr = $('div[data-default-product-desc]')[0].innerHTML;
    let variants = document.querySelectorAll('.variant_description-data[data-customfield-variant-id]');
    let small_desc = $('.accordion-text.js-product-description > p.preview');
    let learn_more_smlbtn = $('.accordion-text.js-product-description > p.preview').find('span.short-link-more');
    if(variants.length != 0){
        let set_default_desc = 0;
        for(i=0; i < variants.length; i++){
          let selectedVal = variants[i].innerHTML.trim();
        if(variants[i].dataset.customfieldVariantId == currentVariant){
          set_default_desc = 1;
          small_desc.html(selectedVal.substring(0, 210));
          small_desc.append(learn_more_smlbtn);
          $('div[data-variant-descr-switcher]').html(selectedVal);
          // $('.full-article > div[data-variant-descr-switcher]').html(selectedVal);
        }
      }
        if(set_default_desc == 0){
        small_desc.html(default_productDescr.substring(0, 210));
        small_desc.append(learn_more_smlbtn);
        $('div[data-variant-descr-switcher]').html(default_productDescr);
        //$('.full-article > div[data-variant-descr-switcher]').html(default_productDescr);   
      }
    }
  }
}


slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     * SelectCallback
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

//       console.log(variant);
      if (!variant) {
//         console.log('!variant');
        var $buttonRow = $('.product-info .button-row');
        $buttonRow.addClass('soldout');
        $buttonRow.find('[name="add"]').prop('disabled',true).text('Unavailable'); 
        $buttonRow.find('.klaviyo-bis-trigger').show()
//         console.log($buttonRow.find('.klaviyo-bis-trigger'));
        
        var waitAndShow = setInterval(function(){
//           console.log('..');
          if($buttonRow.find('.klaviyo-bis-trigger').is(':hidden')){
            $buttonRow.find('.klaviyo-bis-trigger').show();
          } else {
			clearInterval(waitAndShow);
          }
        }, 100);
        setTimeout(function( ) { 
          clearInterval( waitAndShow ); 
        }, 5000);
        return;
      }
      
      // BEGIN SWATCHES
      if (variant) {
        var form = jQuery('#add-to-cart-form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          // console.log('.swatch[data-option-index="' + i + '"] [value="' + variant.options[i] +'"]');
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] [value="' + variant.options[i] +'"]');
          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
      }
      // END SWATCHES
      
      // CT- update buttons
      var $buttonRow = $('.product-info .button-row');
      if(variant.available){
//         console.log('va');
        if($buttonRow.hasClass('soldout')){
          $buttonRow.removeClass('soldout');
          $buttonRow.find('[name="add"]').prop('disabled',false).text('Add to Cart');
          $buttonRow.find('.klaviyo-bis-trigger').hide();
          var waitAndHide = setInterval(function(){
//             console.log('..');
            if($buttonRow.find('.klaviyo-bis-trigger').is(':hidden')){
              clearInterval(waitAndHide);
            } else {
              $buttonRow.find('.klaviyo-bis-trigger').hide();
            }
          }, 100);
          setTimeout(function( ) { 
            clearInterval( waitAndHide ); 
          }, 5000);
        } 
      } else {
//         console.log('NOT');
        $buttonRow.addClass('soldout');
        $buttonRow.find('[name="add"]').prop('disabled',true).text('Sold Out'); 
        $buttonRow.find('.klaviyo-bis-trigger').show();
      }

     
	  $('.sku').html('SKU #'+variant.sku);
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      update_titleVariant(variant.id);
      update_descrVariant(variant.id);
      
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      if (BOLD && BOLD.recurring_orders && BOLD.recurring_orders.app && BOLD.recurring_orders.app.ee &&
          typeof BOLD.recurring_orders.app.ee.emit === 'function'){
        BOLD.recurring_orders.app.ee.emit('variant_changed', {variant:variant});
      }
      
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

//       if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
//         return;
//       }

//       this.$container.trigger({
//         type: 'variantImageChange',
//         variant: variant
//       });
      
      
      // CT- Variant Image Update - using newly assigned variables for safety
      var vImage = variant.featured_image || {};
      var currentvImage = this.currentVariant.featured_image || {};
      
      if (!variant.featured_image || vImage.src === currentvImage.src) {
        return;
      }
      
      //get swiper
      var swiperMain = document.querySelector('.swiper-container-products.gallery-top').swiper;
      var swiperSlideIndex = $('[data-imageid="' + vImage.id + '"]').data('index');
      swiperMain.slideTo(swiperSlideIndex);
    },
	
    
    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
      
      setTimeout(function() {
        $('.shappify-qty-msg').html($('#variant_html_'+$('[name=id]').val()).html()) 
      }, 50);

    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  const sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }
});

$(document).ready(function() {
  /* ---------------------------------------------
  SEARCH BAR
  ------------------------------------------------ */
  $('.search-form').on('submit', function (e) {
    if ($(this).find('input').val() == '') {
      $(this).toggleClass('active-search');
      if ($(this).hasClass('active-search')) {
        $(this).find('input').focus();
      }
      e.preventDefault();
    }
  });

  /* ---------------------------------------------
  HAMBURGER MENU
  ------------------------------------------------ */
  let lastScrollPosition = 0;

  $('.hamburger').on('click', function(e) {
    e.preventDefault();

    if ($('body').hasClass('open-mobile-nav')) {
      $('body').removeClass('open-mobile-nav');
      // Once the body is unfixed, scroll to the last position
      $(window).scrollTop(lastScrollPosition);
    } else {
      // Record last scroll position (for fixed body)
      lastScrollPosition = $(window).scrollTop();
      $('body').addClass('open-mobile-nav');
    }
  });

  /* ---------------------------------------------
    NAV FIXED WHEN SCROLLING UP
  ------------------------------------------------ */
  // Hide Header on on scroll down
  // let didScroll;
  // const lastScrollTop = 0;
  // const delta = 5;
  // const navbarHeight = $('.nav-wrapper').outerHeight();
  //
  // $(window).scroll(function(event) {
  //   didScroll = true;
  // });
  //
  // setInterval(function() {
  //   if (didScroll) {
  //     hasScrolled();
  //     didScroll = false;
  //   }
  // }, 250);
  //
  // hasScrolled();
  //
  // function hasScrolled() {
  //   const distanceScrolled = $(this).scrollTop();
  //
  //   if (distanceScrolled < 30) {
  //     $('.nav-wrapper').removeClass('scrolled');
  //   } else {
  //     $('.nav-wrapper').addClass('scrolled');
  //     // Make sure they scroll more than delta
  //     if (Math.abs(lastScrollTop - distanceScrolled) <= delta) return;
  //
  //     // If they scrolled down and are past the navbar, add class .nav-up.
  //     // This is necessary so you never see what is "behind" the navbar.
  //     if (distanceScrolled > lastScrollTop && distanceScrolled > navbarHeight) {
  //       // Scroll Down
  //       $('.nav-wrapper')
  //         .removeClass('nav-down')
  //         .addClass('nav-up');
  //     } else if (distanceScrolled + $(window).height() < $(document).height()) {
  //       $('.nav-wrapper')
  //         .removeClass('nav-up')
  //         .addClass('nav-down');
  //     }
  //
  //     lastScrollTop = distanceScrolled;
  //   }
  // }

  /* ---------------------------------------------
    DROPDOWN MENUS
  ------------------------------------------------ */
  var menuTimeout;
  var currentMenu;

  $('.nav-wrapper .js-has-dropdown').on('mouseover', function() {
    if ($(window).innerWidth() > 768) {
      currentMenu = $(this).closest('li').find('.collection-link-list');
      clearTimeout(menuTimeout);
      $('.collection-link-list').removeClass('show-dropdown');
      $(this).closest('li').find('.collection-link-list').addClass('show-dropdown');
    }
  });

  $('.collection-link-list').on('mouseover', function () {
    clearTimeout(menuTimeout);
  });

  $('.nav-wrapper .solo-parent-link').on('mouseover', function() {
    $('.show-dropdown').removeClass('show-dropdown');
  });

  $('.nav-wrapper .js-has-dropdown, .collection-link-list').on('mouseout', function(e) {
    if ($(window).innerWidth() > 768) {

      const targetIsShopLink = $(e.relatedTarget).closest('.js-has-dropdown').length > 0;
      const targetIsDropdown =
        $(e.relatedTarget).closest('.collection-link-list').length > 0;
      if (!targetIsShopLink && !targetIsDropdown) {
        menuTimeout = setTimeout(function () {
          currentMenu.removeClass('show-dropdown');

        }, 800);
      } else {
        clearTimeout(menuTimeout);
      }
    }
  });

  $('.nav-wrapper .js-has-dropdown').on('click', function(e) {
    if ($(window).innerWidth() <= 768) {

      e.preventDefault();
      if (!$(this).closest('li').hasClass('active-dropdown-parent-mobile')) {
        $('.mobile-menu nav > ul > li, .mobile-menu .end-content').hide();
        $(this).closest('li').addClass('active-dropdown-parent-mobile');
        $(this).closest('li').fadeIn();
        $(this).closest('li').find('.collection-link-list').fadeIn();
      } else {
        $('.mobile-menu nav > ul > li').hide();
        $(this).closest('li').removeClass('active-dropdown-parent-mobile');
        $(this).closest('li').find('.collection-link-list').hide();
        $('.mobile-menu nav > ul > li, .mobile-menu .end-content').fadeIn();
      }
    }
  });

  $(window).on('resize', function () {
    if ($(window).innerWidth() > 768) {
      $('.mobile-menu nav > ul > li').show();
    }
  });

  // CART DROPDOWN
  $('.nav-wrapper .js-view-cart').on('click', function() {
    if($('#cart-drawer').hasClass('show-dropdown')){
      $('body').removeClass('cart-drawer-active');
      $('.cart-drawer').removeClass('show-dropdown');
    }else {
      $('body').addClass('cart-drawer-active');
      $('.collection-link-list').removeClass('show-dropdown');
      $('.cart-drawer').addClass('show-dropdown');
    }
  });
  
  $('.cart-drawer-overlay, .cart-drawer-close').on('click',function(){
    $('body').removeClass('cart-drawer-active');
    $('.cart-drawer').removeClass('show-dropdown');
  });

//   $('.nav-wrapper .js-view-cart, .cart-trigger .dropdown-menu').on('mouseout', function(e) {
//     const targetIsShopLink = $(e.relatedTarget).closest('.js-view-cart').length > 0;
//     const targetIsDropdown =
//       $(e.relatedTarget).closest('.dropdown-menu').length > 0;
//     if (!targetIsShopLink && !targetIsDropdown) {
//       $('.dropdown-menu').removeClass('show-dropdown');
//     }
//   });


  $('.no-click').on('click', function (e) {
    e.preventDefault();
  });

  /* ---------------------------------------------
    SWIPER
  ------------------------------------------------ */
  const swiper = new Swiper('.swiper-container-col', {
    pagination: {
      el: '.swiper-container-col .swiper-pagination',
      clickable: 'true'
    },
    speed: 600,
    allowTouchMove: true,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: true
    }
  });


  /* ---------------------------------------------
    SWIPER - MOBILE ONLY
  ------------------------------------------------ */
  // breakpoint where swiper will be destroyed
  // and switches to a dual-column layout
  const breakpoint = window.matchMedia( '(min-width:768px)' );

  // keep track of swiper instances to destroy later
  var mobileSwiper = undefined;

  const breakpointChecker = function() {

    // if larger viewport and multi-row layout needed
    if ( breakpoint.matches === true ) {

      // clean up old instances and inline styles when available
      if ( mobileSwiper !== undefined ) {
        $('.swiper-container-sm-only').each(function(){
          this.swiper.destroy( true, true ); // <-- 'this' not 'this[0]' worked for me
        });
      }
      // or/and do nothing
      return;

      // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === false ) {
      // fire small viewport version of swiper
      return enableSwiper();
    }
  };

  const enableSwiper = function() {

    $('.swiper-container-sm-only').each(function(){
      mobileSwiper = new Swiper(this, {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        pagination: {
          el: '.swiper-container-sm-only .swiper-pagination',
          clickable: 'true'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        allowTouchMove: true,
      })
    });
  };

  // keep an eye on viewport size changes
  breakpoint.addListener(breakpointChecker);

  // kickstart
  breakpointChecker();


  /* ---------------------------------------------
  Accordion
  ------------------------------------------------ */
  $('body').on('click', '.accordion-toggle', function() {
    $(this).closest('.accordion-panel').toggleClass('expanded');
  });


  /* ---------------------------------------------
  VIEW CART
  ------------------------------------------------ */
  // $('.js-view-cart').on('click', function(e) {
  //   e.preventDefault();
  //   $('body').addClass('open-cart');
  // });
  //
  // $('.js-close-cart').on('click', function(e) {
  //   e.preventDefault();
  //   $('body').removeClass('open-cart');
  // });

  /* ---------------------------------------------
  SELECTRIC
  ------------------------------------------------ */
  $('.styled-select').selectric();
  /* ---------------------------------------------
  TEXT EFFECT WRAPPER
  ------------------------------------------------ */
  $('.js-animation-wrapper').scrollClass();

  /* ---------------------------------------------
  PROMO SALE BANNER
  ------------------------------------------------ */
  $('.promo-bar-wrapper').on('mouseenter', function(event) {
    $(this).addClass('expanded');
    $('.promo-text-content').addClass('expanded');


  });
  $('.promo-bar-wrapper').on('mouseleave', function(event) {
    $(this).removeClass('expanded');
    $('.promo-text-content').removeClass('expanded');
  });

  /* ---------------------------------------------
  SMOOTH SCROLL
  ------------------------------------------------ */
  $('body').on('click', '.scroll-to', function(e) {
    e.preventDefault();

    var thisTarget = $(this).attr('href');

    if (thisTarget == '#bottom') {
      var targetOffset = $('#top').offset().top + $('#top').outerHeight() - $(window).height();
    } else {
      var targetOffset = $(thisTarget).offset().top;
    }

    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  });

  /* ---------------------------------------------
  EMAIL POPUP
  ------------------------------------------------ */
  function getCookie(name) {
    const dc = document.cookie;
    const prefix = `${name}=`;
    let begin = dc.indexOf(`; ${prefix}`);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else {
      begin += 2;
      var end = document.cookie.indexOf(';', begin);
      if (end == -1) {
        end = dc.length;
      }
    }
    // because unescape has been deprecated, replaced with decodeURI
    // return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  const urlParams = new URLSearchParams(window.location.search);
  // const isPreview = urlParams.get('preview'); // FOR TESTING

  const hasVisited = getCookie('show-email-popup');
  // var hasVisited = null; // FOR TESTING

  // if (true) {
  if (hasVisited === null) {
    setTimeout(function () {
      $('#email-popup').addClass('popped-up');

      // Set a cookie so the popup only shows once every 30 days
      const date = new Date();
      const days = 30;

      // Get unix milliseconds at current time plus number of days
      date.setTime(+date + days * 86400000); // 24 * 60 * 60 * 1000
      window.document.cookie = `${'show-email-popup' +
        '=' +
        'no' +
        '; expires='}${date.toGMTString()}; path=/`;
    }, 3000);
  } else {
    $('#email-popup').remove();
  }
  // }

  $('.close-email-popup').on('click', function(e) {
    e.preventDefault();
    $('#email-popup').removeClass('popped-up');
  });

  $('#email-popup').on('click', function(e) {
    if ($(e.target).closest('.form-wrapper').length == 0) {
      $('#email-popup').removeClass('popped-up');
    }
  });

  $('#email-popup form').on('submit', function(e) {
    e.preventDefault();
    $('#email-popup').removeClass('popped-up');
  });


  // SHIPPING CALCULATOR
  Shopify.Cart.ShippingCalculator.show( {
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat
  } );

  $('.styled-select').selectric('refresh');

});

// Password Page popup

$(".pass-popup").on("click", function() {
  $(".popup-overlay, #Login").addClass("active");
  return false;
});
// Remove Class
$(".close").on("click", function() {
  $(".popup-overlay, #Login").removeClass("active");
});

  // Manual Cart Quantity Update
$(document).on('cart.requestComplete', function(event, cart) {
  
  
  /*Response on Product page*/
  if($('.template-product').length){
    if(window.rsATCButtonClicked == true){
      window.rsATCButtonClicked = false;
      $('.add-to-cart-form .button-row').addClass('success');


      // CT- Add to cart popup
      //atcpShow();

      setTimeout(function(){ 
        $('.add-to-cart-form .button-row button').removeAttr('disabled');
        $('.add-to-cart-form .button-row').removeClass('success');
      }, 5000);
    }
  }
  
  $('.manual-update').each(function(index) {
  	$(this).attr('value', cart.items[index].quantity);
    $(this).val(cart.items[index].quantity);
    $(this).attr('data-update-quantity', index+1);
    updateCartWithInput();
  });

  var cart = CartJS.cart;
  var item_count = 0;
  $.each(cart.items, function(i, cart_item) {
    if (cart_item.product_title.indexOf('DIY Decal') !== -1) {
      item_count += Number(cart_item.properties['Quantity']);
    } else {
      item_count += Number(cart_item.quantity);
    }
  });

  // console.log('item_count',item_count);

  $('.js-cart-counter').html(item_count);

  // console.log('cart.requestComplete', cart);
});

$(document).on('cart.ready', function(event, cart) {
    $('.manual-update').each(function(index) {
      $(this).attr('value', cart.items[index].quantity);
    	$(this).val(cart.items[index].quantity);
      $(this).attr('data-update-quantity', index+1);
      updateCartWithInput();
    });

    // console.log('cart.ready', cart);
    /*
    var cart = CartJS.cart;
    console.log('cart', cart);
    var item_count = 0;
    jQuery.each(cart.items, function(i, cart_item) {
      if (cart_item.product_title.indexOf('DIY Decal') !== -1) {
        item_count += Number(cart_item.properties['Quantity']);
      } else {
        item_count += Number(cart_item.quantity);
      }
    });

    $('.js-cart-counter').html(item_count);*/
  
  // CT- Min Qty
  //   $('.cart-number-input-wrapper [type="number"]').on('change click keyup',function(){
  //     console.log('here change');
  // 	minQtyChecker($(this).closest('#cart-item'));
  //   });
  var qtyFocus;
  var qtyValue;
  $('.cart-number-input-wrapper [type="number"]').on('focus',function(){
    qtyFocus = $(this);
    qtyValue = qtyFocus.val();
  }).on('blur',function(){
    minQtyChecker($(this).closest('#cart-item'));
  });

  $(document).keypress(function(event){
    if(event.which == '13') {
      event.preventDefault();
      if($(event.target).is('.cart-number-input-wrapper [type="number"]')){
        $(event.target).trigger('blur');
        //minQtyChecker($(event.target).closest('#cart-item'));
      } 
    }
  });
});

function updateCartWithInput() {
  var updateButtons = $('.manual-update');
  updateButtons.each(function(){
    $(this).on('keyup', function(){
      CartJS.updateItem($(this).attr('data-update-quantity'), $(this).val());
      // console.log('CartJS: ', CartJS);
    })
  });
}

$('#product-type1').selectric({
  onChange: function() {
    var value = $(this).val();
    contactDropdown(value);
  }
});

function resetSecondDropDown(data) {
  	// console.log(data);
	$('#product-type2').append(data).selectric();
}



/* ---------------------------------------------
MINICART MODIFICATION
------------------------------------------------ */
var existCondition = setInterval(function() {
 if ($(".cart-drawer .cart-item:has(.cart-title:contains('DIY'))").length) {
    // console.log("Exists!");
    clearInterval(existCondition);
    $(".cart-drawer .cart-item:has(.cart-title:contains('DIY'))").each(function(i) {
      $(this).addClass('diy-item');
      //$('.add-remove',this).remove();
    });
 }
}, 100); 

/* ---------------------------------------------
CT- Min Qty
------------------------------------------------ */
function minQtyChecker($cartItem) {
  var $qtyInput = $cartItem.find('[data-label="Quantity"] [type="number"]');
  var qtyValue = $qtyInput.val();
  
  if(typeof $cartItem.data('min-qty') != 'undefined'){
    var minQty = $cartItem.data('min-qty');

    if(qtyValue < minQty){
      alert('The minimum quantity for this product is ' + minQty + '.');

      $qtyInput.val($qtyInput.data('stored-qty'));
      return false;
    }else {
      $qtyInput.data('stored-qty',qtyValue).attr('data-stored-qty',qtyValue);
      return true; 
    }

  } else {
    $qtyInput.data('stored-qty',qtyValue).attr('data-stored-qty',qtyValue);
   	 return true;
  }
}

/* ---------------------------------------------
CT- Add to Cart Popup and Back in Stock pop up
------------------------------------------------ */
$(document).ready(function(){
  atcpInit();

  $('.button.klaviyo-bis-trigger').on('click',function(){;
    var $klaviyoIFrame = $('#klaviyo-bis-iframe').contents();
    var checkExist = setInterval(function() {
      if ($klaviyoIFrame.find('#klaviyo-bis-modal').length) {
        hideBoldVariants();
        clearInterval(checkExist);
      }else {
      }
    }, 300); // check every 100ms
    
    
  });
  
  setTimeout(() => {
             let swatches = $('.pack-swatch');
  			
        if (swatches.length > 0) {
				let active_swatch;
  
  
                for (let i = 0; i < swatches.length; i++) {
                  swatches.eq(i).is(':checked') ? active_swatch = swatches.eq(i).attr('value') : null;
                }


               let product_price = $(".product-info-price").eq(0).find("span").eq(0).text();
              console.log('Active swatch:', active_swatch);

               setPricePerItem( parseFloat(getProductValue(product_price)), parseFloat(getProductValue(active_swatch)) )
              $(".price-per-item").removeClass("hidden-item");
        }
      }, 1000)
  
  
  //console.log('Stored swatch index:', localStorage.getItem('swatch_index'));
 /*	let stored_swatch_index = localStorage.getItem('swatch_index');
  
  
  let swatch_item = stored_swatch_index != null ? swatches.eq(parseInt(stored_swatch_index)).attr('value') : active_swatch;*/
  
 
  
  $(function() {
    $('.swatch [type="radio"]').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this).closest('form').find('#SingleOptionSelector-' + optionIndex).val(optionValue).trigger('change').data('selectric').refresh();;
      
      if ($(this).hasClass("pack-swatch")) {
      	 let product_price = $(".product-info-price").eq(0).find("span").text();
         let value_index = $('.swatch [type="radio"]').index(this);
          console.log('Option index:', value_index);

         // localStorage.setItem('swatch_index', value_index.toString());

          let price_value = parseFloat(getProductValue(product_price)), 
              item_value = parseFloat(getProductValue(optionValue));

          setPricePerItem( price_value, item_value )
      }
          
    });
  });
  
  // trigger change on load for swatches in product page
  if($('.selector-wrapper select').length > 0){
   	 $('.selector-wrapper select').trigger('change');
  }


  
  $('#add-to-cart-form [name="add"]').on('click',function(){
  	window.rsATCButtonClicked = true;
  });
});

const setPricePerItem = ( price_value, item_value ) => {
	let price_per_item = ( price_value / item_value ).toFixed(2);
  
  console.log({
    "Price value": price_value,
    "Item value": item_value
  })
      
      console.log('Price per item:', price_per_item);
      $(".price-per-item span").text(price_per_item)
}

 const getProductValue = (valueItem) => {
	  let pack_value = [], int_array = new Array(10).fill(0);
      int_array.map((item, index) => int_array[index] = index.toString());
   	  int_array.push(".");
      
      valueItem.split("").map(value => int_array.indexOf(value) !== -1 ? pack_value.push(value) : null);
     
  	  return pack_value.join().replace(/,/g, "");
}

function hideBoldVariants(){
  var $klaviyoIFrame = $('#klaviyo-bis-iframe').contents();
  if($('.selector-wrapper .styled-select').length > 0){
    $klaviyoIFrame.find('.selectpicker option').each(function(i,e){
      if($(e).text().indexOf('Default Title') >= 0 || $(e).text().indexOf('(default)') >= 0){
        $(e).hide(); 
      }
    });

    if($klaviyoIFrame.find('.selectpicker option:visible').length < 1) {
      $klaviyoIFrame.find('#variant_select').closest('.form-group').hide();
    }
    
  } else {
    $klaviyoIFrame.find('#variant_select').closest('.form-group').hide();
  }
}

function atcpShow() {
  $('.add-to-cart-popup').fadeIn(function(){
  	$('body').addClass('atcp-active');
    $(this).addClass('is-active');
    
    setTimeout(
      function() {
        if( $('.add-to-cart-popup').hasClass('atcp-active')){
          $('.add-to-cart-popup').fadeOut(function(){
            $('body').removeClass('atcp-active');
            $(this).removeClass('is-active');
          });
        }
      }, 7000);
  });
}

function atcpInit(){
  $('.add-to-cart-popup').on('click',function(e){
    if($(e.target).is('.add-to-cart-popup, .atcp-close, .atcp-close-icon, .atcp-cont , .atcp-cont::before') ){
      $('.add-to-cart-popup').fadeOut(function(){
        $('body').removeClass('atcp-active');
        $(this).removeClass('is-active');
      });
    }
  });
}

// Back to top button
var btn = $('#button');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
});


// Category js
$('body').on('click', '.cate-toggle', function() {
  $(this).closest('.cate-panel').toggleClass('cate-expanded');
});



// navigation sticky scroll js
window.onscroll = function() { backToScrollNav() };

function backToScrollNav() {
  let navigationContainer = document.querySelector('#nav-sticky-wrap');
  let navigationWrapContainer = document.querySelector('#nav-sticky-container');
  let plainLogo = document.querySelector('img.header-sticky-white-none.logo-white.ls-is-cached.lazyloaded');
  let colorLogo = document.querySelector('img.header-sticky-color-logo.logo-color.lazyload');
  if (document.body.scrollTop > 90 || document.documentElement.scrollTop > 90) {
    // navigationContainer.classList.add('sticky-color');
    // navigationWrapContainer.classList.add('sticky-remove-padding');
    document.querySelector('.nav-wrap-header.mobile-inner#nav-sticky-wrap').style.display = "block";
    document.querySelector('.mobile-inner#sticky-scroll-hide').style.display = "none";
  } else {
    // navigationContainer.classList.remove('sticky-color');
    // navigationWrapContainer.classList.remove('sticky-remove-padding');
    document.querySelector('.nav-wrap-header.mobile-inner#nav-sticky-wrap').style.display = "none";
    document.querySelector('.mobile-inner#sticky-scroll-hide').style.display = "block";
  }
}



